import styled from 'styled-components';
import { orange, white } from '../../../../style/colors';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 0;
  align-items: center;
`;

export const FilterChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #fff5f0;
  border: 1px solid ${orange};
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  
  i {
    color: ${orange};
    font-size: 14px;
  }
`;

export const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  margin-left: 4px;
  border-radius: 50%;
  color: #6b7280;
  transition: all 0.2s;
  
  &:hover {
    background: rgba(0, 0, 0, 0.1);
    color: #dc2626;
  }
  
  i {
    font-size: 14px;
    color: inherit;
  }
`;

export const ClearAllButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  background: ${white};
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  color: #dc2626;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: #fef2f2;
    border-color: #fecaca;
  }
  
  i {
    font-size: 14px;
  }
`;

export const Badge = styled.span`
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${orange};
  color: ${white};
  font-size: 10px;
  font-weight: 700;
  border-radius: 9px;
  padding: 0 4px;
`;

